export const getAppPages = (payload?: { page?: number, perPage?: number, search?: string, type: 'ARCHIVE' | 'ACTIVE' }) => ({
    type: "@saga/GET_APP_PAGES",
    payload
});